
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Print from "./print/index.vue";
import Tips from "./tips/index.vue";
import Guides from "./guides/index.vue";
import { PrintData } from "./definitions";
@Component({
  components: {
    Print,
    Tips,
    Guides,
  },
})
export default class WmsPrintPdf extends Vue {
  @Prop({ required: false }) data?: PrintData[];
  @Prop({ required: false, default: "打印" }) businessKey?: string;
  active: "print" | "tips" | "guides" = "print";
  @Watch("data", { immediate: true })
  handleDataChange(val: PrintData[]) {
    //
  }
  handleUnReady() {
    this.active = "tips";
  }
}
